var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuyerryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.0767 11.1921L29.7467 1.47215C24.8967 -0.967853 19.3067 -0.267853 15.2467 2.78215V17.9321H15.3567C16.6067 14.4721 20.7667 14.1321 23.8067 14.1321H35.3867C44.4267 14.1321 45.6167 19.5521 45.6167 28.0421C45.6167 36.5321 44.4767 41.9021 35.3867 41.9021H23.8067C20.1267 41.9021 16.0467 42.1021 13.5567 38.7121C11.6167 36.5321 11.2767 32.9821 11.2767 27.5921C11.2767 25.5621 11.3367 15.4421 11.3767 7.31215C11.3267 7.41215 11.2667 7.50215 11.2067 7.60215L1.47667 26.9321C-1.95333 33.7521 0.796668 42.0521 7.60667 45.4821L26.9367 55.2021C33.7567 58.6321 42.0567 55.8821 45.4867 49.0721L55.2067 29.7421C58.6367 22.9221 55.8867 14.6221 49.0767 11.1921Z",
    fill: "#0096CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2366 17.4321H22.7066C15.7766 17.4321 15.3466 20.2821 15.3466 28.0421C15.3466 36.8121 16.9166 38.5521 22.7066 38.5521H34.2366C41.2666 38.5521 41.4866 35.4821 41.4866 28.0421C41.4866 19.1621 40.5666 17.4321 34.2366 17.4321Z",
    fill: "#0096CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyerryIcon);
export default __webpack_public_path__ + "static/media/buyerry-icon.d38b662049675024f66dd80fddb0318d.svg";
export { ForwardRef as ReactComponent };